import React, { Component } from 'react'
import Learn from '../../components/Learn/Learn'

class LearningRoute extends Component {
  render() {
    return (
      <section>
        <Learn />
      </section>
    );
  }
}

export default LearningRoute
